import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';

const FindTeacher = () => {
  return (
    <div className="min-h-screen bg-[#0b0b0b] text-white">
      <main className="px-4 py-10 sm:px-6 lg:px-8">
        <section className="mx-auto flex max-w-4xl items-center justify-center rounded-[18px] border border-white/10 bg-[#141414] px-6 py-20 text-center shadow-[0_18px_60px_rgba(0,0,0,0.26)] sm:px-10">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[#f6911d]">
              Coming Soon
            </p>
            <h1 className="mt-4 text-3xl font-semibold sm:text-4xl">Find Teacher</h1>
            <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-white/65">
              This feature is still in development and is awaiting release.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default FindTeacher;
